"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isProjectAdmin = isProjectAdmin;
function isProjectAdmin(users, id) {
  var isAdmin = false;
  users.forEach(function (value, key) {
    if (id === value.id && value.is_admin === true) {
      isAdmin = true;
    }
  });
  return isAdmin;
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/ProjectUtil.js
 ** module id = 496
 ** module chunks = 0
 **/